<template>
	<Layout>
		<router-view></router-view>
	</Layout>
</template>
<script>
import appConfig from '@src/app.config';
import Layout from '@layouts/main.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
	page: {
		title: 'Examen - Inicio',
		meta: [{ name: 'description', content: appConfig.description }]
	},
	components: { Layout },
	data: function() {
		return {};
	},
	computed: {
		...mapGetters('menu', ['isOpen'])
	},
	mounted: function() {
		if (this.$router.currentRoute.path === '/') {
			this.$router.push('inicio');
		}
	},
	methods: {
		...mapActions('examenhub', ['iniciar'])
	}
};
</script>
<style module>
.marginlefting {
	margin-left: 60px !important;
}
</style>
